// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import etoak from './etoak'
import router from './router'
import vuetify from '@/plugins/vuetify'
import store from './store'//引入store
import dialog from './components/dialog/index'
import api from './api/api'
import file from './api/file.js'
import axios from './api/http.js'
import utils from './utils/index.js'
import './plugins/et_icon_font/iconfont'

import ETIcon from '@/components/ETIcon'
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'



import VueLazyLoad from 'vue-lazyload'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import './plugins/base'

Vue.use(preview)
Vue.use(VueLazyLoad, {
  error: '',//图片加载不出来 显示图片的路径
  attempt: 3
})

Vue.use(VideoPlayer)
//全局注册icon-svg
Vue.component('et-icon', ETIcon)

import ETCharts from '@/components/charts/ETCharts'
Vue.component('et-charts', ETCharts)

import CardHeader from '@/components/card/CardHeader'
Vue.component('card-header',CardHeader)

Vue.config.productionTip = false
Vue.prototype.$api = api;
Vue.prototype.$file = file;
Vue.prototype.$dialog = dialog;
Vue.prototype.$utils = utils;
Vue.prototype.$axios = axios;


import vuescroll from 'vuescroll';

import animated from 'animate.css'

Vue.use(animated)


Vue.use(vuescroll); // install the vuescroll first
Vue.prototype.$vuescrollConfig = {
  rail: {
    background: '#000'
  },
  bar: {
    background: '#FAFAFA',
  }
};


/**
 * 自定义指令
 */
/* Vue.directive('5',{
  bind:function(el,binding, vnode){
    debugger;
  }
}) */

new Vue({
  el: '#app',
  router,
  vuetify,
  store,//使用store
  components: { etoak },
  template: '<etoak/>'
})



// WEBPACK FOOTER //
// ./src/main.js